'use client';
import React, { useState } from 'react';
import Link from 'next/link';

export default function FooterColumns({ data }) {
  const [activeIndex, setActiveIndex] = useState(null);

  function toggleAccordion(index) {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  }

  return (
    <>
      {data.map((column, index) => {
        return (
          <div
            key={index}
            className={`${activeIndex === index ? 'active' : ''} group border-dawn-grey border-b focus:outline-none lg:border-b-0 lg:pt-4`}
            tabIndex="0"
          >
            <div className="group flex h-[5.5rem] cursor-pointer items-center justify-between transition lg:mb-2 lg:h-5 lg:cursor-default">
              <div
                className="flex w-full justify-between"
                onClick={() => toggleAccordion(index)}
              >
                <span
                  className="sh12 lg:sh11 py-4"
                  role="heading"
                  aria-label={`${column.title} Navigation`}
                  aria-level="2"
                >
                  {column.title}
                </span>
                <span className="mr-4 self-center lg:hidden">
                  <div
                    className={`toggle-open ${activeIndex === index ? 'toggle-close' : ''}`}
                  ></div>
                </span>
              </div>
            </div>
            <div
              className={`${activeIndex === index ? 'active max-h-screen duration-600' : 'duration-300'} max-h-0 overflow-hidden transition-all lg:max-h-96`}
            >
              <nav
                className="mb-5 lg:mb-0"
                title={`${column.title} Navigation`}
              >
                <ul key={index}>
                  {column.items.map((item, index) => {
                    if (item.externalUrl || item.url) {
                      return (
                        <li key={index}>
                          {item.externalUrl ? (
                            <a
                              href={item?.externalUrl}
                              aria-label={`${item?.externalTitle}, opens in new window`}
                              rel="noindex noreferrer"
                              target="_blank"
                              className="body-xs group/link"
                              data-cy="footer-link"
                            >
                              <span className="group-hover/link:text-cozy-cognac pr-1">
                                {item.label}
                              </span>
                              <svg
                                className="inline self-center"
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11"
                                  stroke="#000000"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="group-hover/link:stroke-cozy-cognac"
                                />
                              </svg>
                            </a>
                          ) : (
                            <Link
                              href={`${item.url}${item.query_string ?? ''}`}
                              prefetch={false}
                              className="body-xs hover:text-cozy-cognac"
                              data-cy="footer-link"
                            >
                              {item.label}
                            </Link>
                          )}
                        </li>
                      );
                    }
                  })}
                </ul>
              </nav>
            </div>
          </div>
        );
      })}
    </>
  );
}
